import React from 'react';
import { Form, Tooltip, Input, DatePicker, Select, message, InputNumber } from 'antd';
import ModalDom from '../../../../../components/Modal';
import DetailTitle from '../../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../../components/Custom';
import { config, postFrom } from '../../../../../axios';
import { backMoneyType } from '../../../../../axios/dictionaries';
import moment from 'moment';
import { handleDeepCopy } from '../../../../../utils';

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.initState = {
            loading: false,
            data: {},
        };
        this.state = {
            ...handleDeepCopy(this.initState)
        };
    }

    handleCancel = () => {
        this.id = undefined;
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    loadPackage = ({ id }) => {
        this.setState({ loading: true });
        this.billId = id;
        postFrom({ url: config.API_bill_getPayableVo, data: { billId: this.billId } }).then(res => {
            this.setState({ data: res || {}, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.setState({ loading: true });
                values.billId = this.billId;
                values.payDate = values.payDate ? values.payDate.format('YYYY-MM-DD') : '';
                postFrom({ url: config.API_bill_payOffline, data: values }).then(res => {
                    message.success('付款成功')
                    this.handleCancel();
                    this.props.handleGetList();
                }).catch(err => {
                    message.error(err.message || '付款失败');
                    this.setState({ loading: false });
                });
            }
        })
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data,
        } = this.state;

        let endPayTypes = backMoneyType.find(item => item.value === data.endPayType);

        return <ModalDom
            title="退款"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form>
                    <CustomRow>
                        <CustomCol label="小区/楼栋" required={false}>
                            <span className="not-edit">{data.buildName}</span>
                        </CustomCol>
                        <CustomCol label="房号" required={false}>
                            <span className="not-edit">{data.roomNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="姓名" required={false}>
                            <span className="not-edit">{data.nowCustomerName}</span>
                        </CustomCol>
                        <CustomCol label="证件号码" required={false}>
                            <span className="not-edit">{data.nowCredentialNumber}</span>
                        </CustomCol>
                        <CustomCol label="手机号码" required={false}>
                            <span className="not-edit">{data.nowCustomerPhone}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="可退金额" required={false}>
                            <span className="not-edit">{data.payableMoney}</span>
                        </CustomCol>
                        <CustomCol label="退款原因" required={false}>
                            <span className="not-edit">{data.feeRemark}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow>
                        <CustomCol label="应退方式" required={false}>
                            <span className="not-edit">{endPayTypes ? endPayTypes.title : null}</span>
                        </CustomCol>
                        <CustomCol label="账号信息" required={false} colStyle={{ width: '500px' }}>
                            <span className="not-edit">{data.endPayAccount}</span>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="实退" />
                    <CustomRow>
                        <CustomCol label="退款方式">
                            {getFieldDecorator('payType', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: 1
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                >
                                    {backMoneyType.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol label="退款日期">
                            {getFieldDecorator('payDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: moment()
                            })(
                                <DatePicker
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="退款流水" required={false}>
                            {getFieldDecorator('searialNumber')(
                                <Input
                                    autoComplete={"off"}
                                    placeholder="请输入"
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="退款说明" required={false} colStyle={{ width: '500px' }}>
                            {getFieldDecorator('payRemark')(
                                <Input
                                    autoComplete={"off"}
                                    placeholder="请输入"
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                </Form>
            </div>
        </ModalDom >
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Bill/components/Payment/Refund/index.js